export default __webpack_public_path__ + "static/media/iab-benefit-boost.b4fb3008.svg";